export default function Seperator() {
    return (
        <div className="border-t-1 border-muted rounded-full mt-8" />
    )
}